var map = {
	"./KNDC.png": "2c95",
	"./Polygon-2.svg": "c7d0",
	"./Polygon.svg": "e3fa",
	"./account-icon.svg": "1e2a",
	"./association-logo.png": "02f2",
	"./background-image.png": "81c4",
	"./big-circle.svg": "fceb",
	"./bird.jpg": "4f2f",
	"./building.jpg": "5d3c",
	"./building1.jpg": "9f96",
	"./contact.png": "9fa8",
	"./default-discussion-image.png": "3bd5",
	"./event-1.jpg": "f200",
	"./hero01__1615360120_203.109.44.209.jpg": "70f7",
	"./hero02__1615360295_203.109.44.209.jpg": "c83a",
	"./hero03__1615360359_203.109.44.209.jpg": "ece9",
	"./hero04__1615360459_203.109.44.209.jpg": "333f",
	"./icon.png": "555a",
	"./info-1.jpg": "ff84",
	"./info-2.jpg": "d3ca",
	"./info-3.jpg": "9563",
	"./light_desktop.svg": "95d4",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./national-society-logo.png": "419c",
	"./nscontact.jpg": "be62",
	"./pay_methods_branding.png": "a71b",
	"./planet.jpg": "e219",
	"./profile.jpg": "3a19",
	"./qr-code.webp": "8fd1",
	"./sky.jpg": "e4fe",
	"./society.jpg": "f849",
	"./squirrel.jpg": "2773"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";